<mat-toolbar
  [attr.data-aue-resource]="'urn:aemconnection:/content/srp/global/' + languageCode + '/footer/jcr:content/root/container/srp_container/footerlinks_copy'"
  data-aue-type="component" [attr.data-aue-model]="'srp/components/common/footerlinks'" data-aue-label="Footer Links" data-aue-behavior="component"
  class="footer-toolbar">
  @let footerState = footerPageState();
  <!-- <span class="footer-copyright">&copy; 2025 Stellantis</span> -->
  <div class="footer-metadata">
    @if (footerState.pageContent?.length) {
    @for (label of footerState.pageContent; track label.labelId || $index) {
    @if (label.labelId === LABELS.COPYRIGHT_TEXT) {
    <span class="footer-copyright"
      [attr.data-aue-resource]="'urn:aemconnection:/content/srp/global/' + languageCode + '/footer/jcr:content/root/container/srp_container/footerlinks_copy/labels/item' + $index"
      data-aue-prop="label" data-aue-type="text" data-aue-behavior="field"
      >{{ label.label || "© 2025 Stellantis" }}</span>
    }
    }
    } @else {
    <span class="footer-copyright">© 2025 Stellantis</span>
    }
    <span [class]="(build_env=='prd')?'srp-build-info d-none':'srp-build-info'"
      [matTooltip]="'Version :'+ build_version      +' | Environment :'+build_env_label       +'| Build Date :'+ build_date">{{build_version}}</span>
  </div>

  <div class="footer-links"
    data-aue-prop="footerLinks" data-aue-type="container" data-aue-behavior="container" data-aue-filter="footerLink">
    @for(item of footerPageState().footerComponentLinks; track $index) {
    <div
      [attr.data-aue-resource]="'urn:aemconnection:/content/srp/global/' + languageCode + '/footer/jcr:content/root/container/srp_container/footerlinks_copy/footerLinks/item' + $index"
      data-aue-type="component" [attr.data-aue-model]="'srp/components/common/footerlinks/item'"
      data-aue-label="Footer Link Item" data-aue-behavior="component">
      <span class="item">
        <srp-link title="{{ item.label }}" data-aue-prop="label" data-aue-type="text" data-aue-behavior="field" 
          (click)="onDocumentLinkClick($event, item.document , item.type, item.label )"
          (keydown.enter)="onDocumentLinkClick($event, item.document , item.type, item.label )">
        </srp-link>
        <span data-aue-prop="document" data-aue-type="media" data-aue-filter="dam"
          data-aue-label="Document Link" data-aue-behavior="field" 
          > </span>
     
      </span>
    
    </div>
    }
  </div>
</mat-toolbar>